import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const clinicalCharacteristicService = {
    LoadData,
    SaveData
};
function LoadData(pid) {
    return WebServiceWrapper.Get(`/clinicalCharacteristic/LoadClinicalData?patientId=${pid}&isAdmin=${IsAdmin()}`);
}
function SaveData(payload) {
    return WebServiceWrapper.Post("/clinicalCharacteristic/SaveClinicalData", payload);
}